interface HeroProps {
  onCTAClick: () => void;
}

export default function Hero({ onCTAClick }: HeroProps) {
  const scrollToLevels = () => {
    const levelsElement = document.getElementById('sponsorship-levels');
    if (levelsElement) {
      levelsElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/e4b36fe3fcbc85a6a3a28998a8d0ed6b.jpeg"
          alt="Youth Football Team"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-4 left-4 sm:top-8 sm:left-8 z-20">
        <img
          src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/b4d28f31b85e5c51af718a9e77abeb89.png"
          alt="CYFA Logo"
          className="h-12 sm:h-16 md:h-20 w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-5 sm:px-8 text-center pt-24 pb-12 sm:pt-28 sm:pb-16">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-5 sm:mb-8 leading-tight tracking-tight">
          Support{' '}
          <img
            src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/e9e0482d01eb0b0bb794609614b595e4.png"
            alt="Cal"
            className="inline-block h-[1.4em] w-auto align-middle"
          />{' '}
          Kids.<br />
          <span className="text-yellow-400">Put Your Business</span><br />
          In Front Of Hundreds<br />
          Of{' '}
          <img
            src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/e9e0482d01eb0b0bb794609614b595e4.png"
            alt="Cal"
            className="inline-block h-[1.4em] w-auto align-middle"
          />{' '}
          Families.
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-100 mb-8 sm:mb-12 max-w-3xl mx-auto font-medium leading-relaxed">
          Become a sponsor of the Caledonia Youth Football Association and show the community your business stands behind youth athletics.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
          <button
            onClick={onCTAClick}
            className="w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-purple-700 hover:bg-purple-800 text-white text-base sm:text-xl font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Become A CYFA Sponsor
          </button>

          <button
            onClick={scrollToLevels}
            className="w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-white hover:bg-gray-100 text-purple-900 text-base sm:text-xl font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            View Sponsorship Opportunities
          </button>
        </div>
      </div>
    </section>
  );
}
